/**
 * Оптимизированные select для снижения Supabase egress.
 * Используются во всех запросах к recipes / chat_history.
 */

/** Колонки для списков рецептов (без embed). image_url удалён из таблицы recipes. */
export const RECIPES_LIST_SELECT =
  'id, title, created_at, cooking_time_minutes, tags, child_id, member_id, description, rating, nutrition_goals';

/**
 * Select для одного рецепта с ингредиентами и шагами (без лимита по количеству).
 * meal_type — для шаринга (тип приёма: Завтрак/Обед/Ужин/Перекус).
 */
export const RECIPES_DETAIL_SELECT = `${RECIPES_LIST_SELECT}, meal_type, chef_advice, advice, source, servings_base, servings_recommended, calories, proteins, fats, carbs, ingredients:recipe_ingredients(name, amount, unit, substitute, display_text, canonical_amount, canonical_unit, category, display_amount, display_unit, display_quantity_text, measurement_mode), steps:recipe_steps(instruction, step_number)`;

/** Минимальные поля chat_history для отображения (meta — для follow-up после blocked). */
export const CHAT_HISTORY_SELECT = 'id, message, response, created_at, user_id, child_id, message_type, recipe_id, archived_at, meta';

export const RECIPES_PAGE_SIZE = 10;
/** Лимит чата: храним только последние 10 записей (карусель). */
export const CHAT_LAST_MESSAGES = 10;
export const SUPABASE_DEBOUNCE_MS = 200;
